import React, { forwardRef, useState } from "react";
import { AlertLevel } from "./AlertMessage";
import ModalAlert from "./ModalAlert";

export interface Props {
	id?: string;
	className?: string;
	disabled?: boolean;
	type?: AlertLevel;
	title?: string;
	message: string;
	confirmLabel?: string;
	cancelLabel?: string;
	onConfirm: () => void;
	onCancel?: () => void;
	children: React.ReactNode;
}

export const ButtonWithConfirm = forwardRef<HTMLButtonElement, Props>((props, ref) => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handleOpenDialog = () => {
		setIsDialogOpen(true);
	};
	const handleConfirm = () => {
		setIsDialogOpen(false);
		props.onConfirm();
	};
	const handleCancel = () => {
		setIsDialogOpen(false);
		if (props.onCancel) props.onCancel();
	};

	return (
		<>
			<button
				id={props.id}
				ref={ref}
				className={props.className ?? "btn btn-neutral"}
				onClick={handleOpenDialog}
				disabled={props.disabled}>
				{props.children}
			</button>

			{isDialogOpen && (
				<ModalAlert
					open={isDialogOpen}
					title={props.title ?? "Are You Sure?"}
					message={props.message}
					type={props.type ?? AlertLevel.Warning}
					confirmLabel={props.confirmLabel ?? "OK"}
					cancelLabel={props.cancelLabel ?? "Cancel"}
					onConfirm={handleConfirm}
					onCancel={handleCancel}
				/>
			)}
		</>
	);
});

export default ButtonWithConfirm;
